import script from "./LoginPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPicker.vue?vue&type=script&setup=true&lang=js"

import "./LoginPicker.vue?vue&type=style&index=0&id=081157e7&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081157e7"]])

export default __exports__